import React from "react";
import { Html } from "../../../html";
import styles from "./styles.modules.scss";
import { Accordion } from "../../../accordion";

export const BlockHtml = ({
    title,
    body,
    accordion,
}: InboxArticleTextBlock) => {
    return (
        <div className={`block-html ${styles.blockHtml}`}>
            {title && accordion !== "yes" && (
                <div className={`title ${styles.title}`}>{title}</div>
            )}
            {accordion === "yes" ? (
                <Accordion title={title} body={<Html html={body} />} />
            ) : (
                <Html html={body} />
            )}
        </div>
    );
};
